import permission from './permission'
import role from './role'
import { Draggable } from 'draggable-vue-directive'

let Directives = {
  install(Vue, options) {
    Vue.use(permission)
    Vue.use(role)
    Vue.directive('draggable', Draggable)
  }
}

export default Directives
